import React, { CSSProperties, useEffect, useRef } from 'react';
import { publicUrl } from '@utils/env';
import './HeroLogin.css';
import CanvasNest from 'canvas-nest.js';
// có thể sau đó cần custom xác thực khác tại component này luôn

export default function HeroLogin({ children }: { children: any }) {
  const CNet = useRef<any>(null);
  const config = {
    color: '255,255,255',
    count: 199,
    zIndex: 1
  };

  useEffect(() => {
    const wapperElm = document.querySelector('#wapper-login-IC');
    // Using config rendering effect at 'element'.
    if (wapperElm) {
      const cn = new CanvasNest(wapperElm, config);
      CNet.current = cn;
    }

    return () => {
      // destroy
      if (CNet.current) CNet.current.destroy();
    };
  }, []);

  return (
    <div style={{ backgroundColor: 'white; height: 100vh' }}>
      <div
        id="wapper-login-IC"
        className="ant-pro-form-login-page css-w98ooa"
        style={{
          position: 'relative',
          backgroundImage: `url("${publicUrl}/img/login/login-bg.svg")`
        }}
      >
        <div style={styles}>
          <video
            src={`${publicUrl}/video/login.mp4`}
            autoPlay // tự động play hay đứng yên
            loop
            muted
            crossOrigin="anonymous"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          ></video>
        </div>
        <div className="ant-pro-form-login-page css-w98ooa">
          <div className="ant-pro-form-login-page-notice css-w98ooa">
            <div
              className="ant-pro-form-login-page-notice-activity css-w98ooa"
              style={{
                boxShadow: ' rgba(0, 0, 0, 0.2) 0px 0px 8px; color: rgba(255, 255, 255, 0.85)',
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.25)',
                backdropFilter: 'blur(2px)'
              }}
            >
              <div className="ant-pro-form-login-page-notice-activity-title css-w98ooa font-semibold">
                Quản lý đơn hàng
              </div>
              <div className="ant-pro-form-login-page-notice-activity-subTitle css-w98ooa">
                Trang quản lý đơn và xử lý đơn của công ty với các quá trình trao đổi bảo mật thông tin, đảm bảo an
                toàn, hiệu quả, tiết kiệm thời gian và công sức vận hành.
              </div>
              {/* <div className="ant-pro-form-login-page-notice-activity-action css-w98ooa">
                <button
                  type="button"
                  className=""
                  style={{
                    borderRadius: '20px',
                    background: 'rgb(31, 31, 31)',
                    color: 'rgb(22, 104, 220)',
                    width: '120px'
                  }}
                >
                  <span>Xem thêm</span>
                </button>
              </div> */}
              <div className="border-b border-b-gray-300 pb-2"></div>
              <div className="ant-pro-form-login-page-notice-activity-title css-w98ooa font-semibold">
                Điều khoản Cookie
              </div>
              <div className="ant-pro-form-login-page-notice-activity-subTitle css-w98ooa">
                Bằng việc click vào `Đăng nhập`, bạn đồng ý rằng website của chúng tôi có thể lưu trữ cookie trên thiết
                bị của bạn và sử dụng chúng theo Chính sách cookie hệ thống. Chúng tôi sẽ không cung cấp bất kỳ thông
                tin cá nhân trong tài khoản của bạn cho bên thứ ba nào khác. Adsun trân trọng.
              </div>
            </div>
          </div>
          <div className="ant-pro-form-login-page-left css-w98ooa">
            <div
              className="ant-pro-form-login-page-container css-w98ooa"
              style={{ backgroundColor: 'rgba(0, 0, 0, 0.65)', backdropFilter: 'blur(2px)' }}
            >
              <div className="ant-pro-form-login-page-top css-w98ooa">
                <div className="ant-pro-form-login-page-header css-w98ooa">
                  <span className="ant-pro-form-login-page-logo css-w98ooa">
                    <img src={`${publicUrl}/img/login/logo_adsun_only.png`} />
                  </span>
                  <span className="ant-pro-form-login-page-title css-w98ooa">ADSUN OM</span>
                </div>
                <div className="ant-pro-form-login-page-desc css-w98ooa">Trang điều hành hoạt động công ty</div>
              </div>
              <div className="ant-pro-form-login-page-main css-w98ooa">
                {children}{' '}
                <div className="ant-pro-form-login-page-other css-12ss4cj">
                  <div
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
                  >
                    <div
                      className="ant-divider css-1szppdt ant-divider-horizontal ant-divider-with-text ant-divider-with-text-center ant-divider-plain"
                      role="separator"
                    >
                      <span className="ant-divider-inner-text">
                        <span style={{ color: 'rgba(220, 220, 242, 0.85)', fontWeight: 'normal', fontSize: '14px' }}>
                          Đăng nhập khác
                        </span>
                      </span>
                    </div>
                    <div
                      className="ant-space css-1szppdt ant-space-horizontal ant-space-align-center"
                      style={{ gap: '24px' }}
                    >
                      <div className="ant-space-item">
                        <div className="flex justify-center align-middle flex-col h-[40px] w-[40px] border-[1px solid rgb(1, 65, 152)] rounded-full">
                          <span
                            role="img"
                            aria-label="alipay"
                            style={{ color: 'rgb(22, 119, 255)' }}
                            className="anticon anticon-alipay text-base cursor-pointer"
                          >
                            <img src="https://cdn-icons-png.flaticon.com/128/281/281764.png" width={20} />
                          </span>
                        </div>
                      </div>
                      <div className="ant-space-item">
                        <div className="flex justify-center align-middle flex-col h-[40px] w-[40px] border-[1px solid rgb(1, 65, 152)] rounded-full">
                          <span
                            role="img"
                            aria-label="taobao"
                            style={{ color: 'rgb(255, 106, 16)' }}
                            className="anticon anticon-taobao text-base cursor-pointer"
                          >
                            <img src="https://cdn-icons-png.flaticon.com/128/518/518705.png" width={20} />
                          </span>
                        </div>
                      </div>
                      <div className="ant-space-item">
                        <div className="flex justify-center align-middle flex-col h-[40px] w-[40px] border-[1px solid rgb(1, 65, 152)] rounded-full">
                          <span
                            role="img"
                            aria-label="weibo"
                            style={{ color: 'rgb(24, 144, 255)' }}
                            className="anticon anticon-weibo text-base cursor-pointer"
                          >
                            <img src="https://cdn-icons-png.flaticon.com/128/179/179309.png" width={20} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles: CSSProperties = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: '100%',
  overflow: 'hidden',
  height: '100vh',
  zIndex: '1',
  pointerEvents: 'none'
};
